import { SearchCriteria } from 'src/app/core/interfaces/search-criteria.interface';
import { AppInterface } from '../../../interfaces/app.interface';
import { FIELD_PRIORITY_WEIGHT, SEARCH_FIELD, SearchPriorityConfig } from 'src/app/core/interfaces/search-priority-config';

export class AppTitleCriteria implements SearchCriteria {
  getMatchScore(_app: AppInterface, _query: string): number {
    const title = _app.isBookmark ? (_app.appName?.toLowerCase() ?? '') : (_app.title?.toLowerCase() ?? '');
    
    if(title === _query) {
      return 5;
    }
    if(title?.startsWith(_query)) {
      return 3;
    }
    if(title?.includes(_query)) {
      return 1;
    }
    return  0;
  }

  getRelevanceFieldWeightAndMatchScore(_app: AppInterface, _query: string): SearchPriorityConfig {
    return {
      relevanceField: SEARCH_FIELD.TITLE,
      fieldPriorityWeight: FIELD_PRIORITY_WEIGHT.TITLE,
      matchScore: this.getMatchScore(_app, _query),
    }
  }
}
